import React from 'react';
import { Box, Typography } from '@mui/material';
import { Button } from 'reactstrap';
import colors from 'src/styles/equalution/colors';
import { getCurrencySymbol } from 'src/lib/utils';

type ChallengeAddOnCardProps = {
  name: string;
  price: string;
  onAdd: () => void;
  description?: string;
  isLoading?: boolean;
};

const ChallengeAddOnCard: React.FC<ChallengeAddOnCardProps> = ({
  name,
  price,
  description = 'Description TBC',
  onAdd,
  isLoading = false,
}) => {
  return (
    <Box
      sx={{
        backgroundColor: colors.OFF_WHITE,
        borderRadius: '20px',
        padding: '20px',
        display: 'flex',
        flexDirection: 'column',
        gap: 1,
        marginBottom: '24px',
      }}>
      {/* Title Row */}
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
        <Typography
          sx={{
            fontSize: '16px',
            fontWeight: 700,
            color: colors.OFF_BLACK,
            lineHeight: '24px',
            textTransform: 'uppercase',
            paddingRight: '60px',
          }}>
          {name}
        </Typography>
      </Box>

      {/* Divider */}
      <Box
        sx={{
          width: '25%',
          height: '1px',
          backgroundColor: colors.BLUEBERRY_HALF,
          opacity: 0.5,
        }}
      />

      {/* Pricing/Description and Button Row */}
      <Box
        sx={{
          display: 'flex',
          alignItems: 'flex-start',
          justifyContent: 'space-between',
          gap: 2,
        }}>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: 0,
            flex: 1,
          }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0 }}>
            <Typography
              sx={{
                fontSize: '20px',
                fontWeight: 700,
                color: colors.SALAD,
                lineHeight: '32px',
              }}>
              {getCurrencySymbol()}
              {price}
            </Typography>
          </Box>

          <Typography
            sx={{
              fontSize: '14px',
              fontWeight: 400,
              color: colors.OFF_BLACK,
              paddingRight: '60px',
            }}>
            {description}
          </Typography>
        </Box>

        <Button
          disabled={isLoading}
          onClick={onAdd}
          style={{ width: '72px' }}
          size="sm">
          Add
        </Button>
      </Box>
    </Box>
  );
};

export default ChallengeAddOnCard;
